var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 29,
    cy: 29,
    r: 29,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37 31C38.1046 31 39 30.1045 39 29C39 27.8955 38.1046 27 37 27L31 27L31 21C31 19.8954 30.1045 19 29 19C27.8955 19 27 19.8954 27 21L27 27L21 27C19.8955 27 19 27.8955 19 29C19 30.1045 19.8955 31 21 31L27 31L27 37C27 38.1045 27.8955 39 29 39C30.1045 39 31 38.1045 31 37L31 31L37 31Z",
    fill: "#FFC000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 10C18.5066 10 10 18.5066 10 29C10 39.4935 18.5066 48 29 48C39.4935 48 48 39.4935 48 29C48 18.5066 39.4935 10 29 10ZM12.6512 29C12.6512 19.9708 19.9708 12.6512 29 12.6512C38.0292 12.6512 45.3488 19.9708 45.3488 29C45.3488 38.0292 38.0292 45.3488 29 45.3488C19.9708 45.3488 12.6512 38.0292 12.6512 29Z",
    fill: "#FFC000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.a87d69449386a2362a7f5bb34a99fd4a.svg";
export { ForwardRef as ReactComponent };